module.exports = __webpack_public_path__ + "fontello.d375f1773154ebd6dd8e.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/font/fontello.woff2?3640046
// module id = ../../../../../src/assets/font/fontello.woff2?3640046
// module chunks = styles